import {Exclude, Type} from 'class-transformer';
import {GLOBAL, IdCodeNameModel, UserModel} from 'common-shared';
import {BaseConnectionModel, CostPriceComponentPriceModel, ExpressionModel, PropertyMappingModel, SpecLineModel} from "web-shared";

export class ResourceModel extends IdCodeNameModel {
  constructor(init?: Partial<ResourceModel>) {
    super();
    Object.assign(this, init);
  }

  ResourceTypeClv?: string;
  ResourceQuantityConstraintsClv?: string;
  AssignedResourceQuantityFlagClv?: string;

  Production: ExpressionModel = new ExpressionModel();
  Setup: ExpressionModel = new ExpressionModel();
  Teardown: ExpressionModel = new ExpressionModel();
  Yield: ExpressionModel = new ExpressionModel();
  ProductionFactor?: number;
  ResourceLTimeBuffer?: string;
  ResourceRTimeBuffer?: string;

  KindClv: string;
  BottleneckClv: string;
  @Type(() => ResourceConnectionModel)
  FromResourceConnections: ResourceConnectionModel[] = [];
  @Type(() => ResourceConnectionModel)
  ToResourceConnections: ResourceConnectionModel[] = [];
  @Type(() => PropertyMappingModel)
  ProcedureItemProperties: PropertyMappingModel[] = [];
  @Type(() => CostPriceComponentPriceModel)
  CostPriceComponentPrices: CostPriceComponentPriceModel[] = [];
  UserId: string;
  @Exclude({ toPlainOnly: true })
  User: UserModel;
  RowVersion: string;

  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];

  Comment: string;
  StatusClv: string;
  StatusCl: string;

  static CreateDefault(init?: Partial<ResourceModel>) {
    return Object.assign(new ResourceModel(), {
      BottleneckClv: GLOBAL.Classificators.Bottleneck.Normal,
      KindClv: GLOBAL.Classificators.ResourceKind.Machine,
      ResourceTypeClv: GLOBAL.Classificators.ResourceType.MainResource
    } as ResourceModel, init);
  }

  isValid(): boolean {
    return this.Specs.every(spec => spec.isValid());
  }
}

export class ResourceConnectionModel extends BaseConnectionModel {
  constructor(init?: Partial<ResourceConnectionModel>) {
    super();
    Object.assign(this, init);
  }

  Quantity?: number;
  TypeClv: string;
  ToResourceId: string;
  FromResourceId: string;
}

